import { useQuery } from "@tanstack/react-query";
import { getTargetareMapare } from "@/api/endpoints/targetareConfig";
import { queryKeys } from "@/lib/queryClient";

export function useGetTargetareMapare() {
  return useQuery({
    queryKey: queryKeys.targetare.mapare(),
    queryFn: getTargetareMapare,
    select: (response) => response.data,
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
}
